import React, { useEffect, useState, useRef } from 'react';
import '../CreateImages/imageCreate.css'
import Breadcumb from '../../components/Breadcumb/Breadcumb'
import { Container } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import TextCard from '../../components/ImageEditor/TextCard';
import ImageCard from '../../components/ImageEditor/ImageCard';
import PhotoHolder from '../../components/ImageEditor/PhotoHolder';
import AddImageModal from '../../components/ImageEditor/AddImageModal';
import AddPhotoModal from '../../components/ImageEditor/AddPhotoModal';
import { Images, Alerts } from '../../helpers';
import { v4 as uuidv4 } from "uuid";
import { useOutsideAlerter } from '../../components/DetectOutsideClick';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';


import {
    accgetImageWithProperty,
    AddImageProperty,
    UpdateTextAlignment,
    UpdateFontFamily,
    UpdateFontSize,
    UpdateFontColor,
    UpdateLetterSpacing,
    UpdatePropertyTranslation,
    UpdatePropertyText,
    UpdateTextAreaSize,
    UpdateImageSize,
    RemoveImageProperty,
    UpdatePhotoHolderSize,
    UpdatePhoto,
    UpdateLineHeight,
    UpdateBackgroundColor,
    UpdateBoxRotation,
    UpdateTextStroke
} from '../../store/Actions/appActions';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '@material-ui/icons/Delete';
import Draggable from "react-draggable";

import fontJson from '../../data/font.json';
import Button from '@material-ui/core/Button';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';
import ButtonGroup from "@material-ui/core/ButtonGroup";
import ColorPicker from '../../components/ImageEditor/ColorPicker';
import LineHeightPicker from '../../components/ImageEditor/LineHeightPicker';
import RotatePicker from '../../components/ImageEditor/RotatePicker';
import AlignmentPicker from '../../components/ImageEditor/AlignmentPicker';
import LatterSpacingPicker from '../../components/ImageEditor/LatterSpacingPicker';
import domtoimage from 'dom-to-image';
import FontFamilyPicker from '../../components/ImageEditor/FontFamilyPicker';
import BackgroundColorPicker from '../../components/ImageEditor/BackgroundColorPicker';
import StrokePicker from '../../components/ImageEditor/StrokePicker';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Create Image",
        page_path: "/",
        icon: "tachometer",
    }
]
function CreateImage({ props }) {
    const createdImage = useSelector(state => state.image.image);
    var imageProperties = useSelector(state => state.image.image_property);
    const showLoading = useSelector(state => state.image.showLoading);

    // const [refresh, setRefresh] = useState(false);
    // const [isNowFocus, setFocusTextArea] = useState(false)
    const [currentItemProperty, setCurrentItemProperty] = useState(null);
    const [isLoading, setLoading] = useState(false);

    const [isEdit, setEdit] = useState(false);
    //image modal
    const [isOpenPhotoModal, setOpenPhotoModal] = useState(false);
    const openPhotoModal = () => {
        setOpenPhotoModal(true);
    };
    const closePhotoModal = () => {
        setOpenPhotoModal(false);
    };


    //image modal
    const [isOpenImageModal, setOpenImageModal] = useState(false);
    const openImageModal = () => {
        setOpenImageModal(true);
    };
    const closeImageModal = () => {
        setOpenImageModal(false);
    };

    const dispatch = useDispatch();
    let { id } = useParams();
    const getData = async () => {
        dispatch(accgetImageWithProperty(id));
    }
    useEffect(() => {
        getData();
    }, [])

    const addText = async () => {
        let newNote = {
            created_image_id: id,
            property_id: uuidv4(),
            is_image: false,
            is_text: true,
            is_photo: false,
            text_label: 'Add Text',
            font_size: "20px",
            line_height: "20px",
            width: "200px",
            height: "32px",
            rotate_box: "0deg",
            background_color: "transparent",
            text_stroke: "0px transparent",
            font_family: "Arimo",
            font_weight: 500,
            letter_spacing: "0px",
            text_alignment: 'center',
            color: "#000",
            translate_option: {
                position_x: 0,
                position_y: 0
            }
        };
        // value.created_image_id = id;
        dispatch(AddImageProperty(newNote))
    }
    // const removeText = (del_id) => {
    //     //    dispatch(LoadingToggle(true))
    //     dispatch(removeImageProperty(del_id));
    //     window.location.reload();
    // }

    const addPhotoHolder = async (values) => {
        let newNote = {
            created_image_id: id,
            property_id: uuidv4(),
            is_image: false,
            is_text: false,
            is_photo: true,
            text_label: null,
            font_size: "0px",
            width: `${values.width}px`,
            height: `${values.height}px`,
            font_family: null,
            font_weight: null,
            letter_spacing: null,
            text_alignment: 'center',
            color: null,
            image_url: null,
            translate_option: {
                position_x: 0,
                position_y: 0
            }
        };
        dispatch(AddImageProperty(newNote))
    }

    function updatePhoto(values) {
        dispatch(UpdatePhoto(values));
    }



    const addFocus = (id) => {
        const currentItem = imageProperties.find(el => el.property_id === id);
        setCurrentItemProperty(currentItem);
        setEdit(true);
    }
    // const removeFocus = () => {
    //     setFocusTextArea(false);
    //     // setCurrentItemProperty(null)
    // }
    // const onEditImage = (id) => {
    //     const currentItem = imageProperties.find(el => el.property_id === id);
    //     setCurrentItemProperty(currentItem);

    // }




    function updateInputText(element, value) {
        const data = {
            text_label: value,
            id: currentItemProperty.property_id
        }

        dispatch(UpdatePropertyText(data));
    }


    const updateTextareaSize = (value) => {
        const data = {
            text_area_width: value.width,
            text_area_hieght: value.height,
            id: value.property_id
        }
        dispatch(UpdateTextAreaSize(data));
    }
    const updateImageSize = (value) => {
        const data = {
            text_area_width: value.width,
            id: value.property_id
        }

        dispatch(UpdateImageSize(data));
    }

    const updatePhotoHolderSize = (value) => {
        const data = {
            photo_holder_width: value.width,
            photo_holder_height: value.height,
            id: value.property_id
        }

        dispatch(UpdatePhotoHolderSize(data));
    }

    const handleChangeFontFamily = (value, weight) => {
        let font = fontJson.find(el => el.value === value && el.font_weight === weight);
        const data = {
            font_family: font.value,
            font_weight: font.font_weight,
            id: currentItemProperty.property_id
        }
        dispatch(UpdateFontFamily(data));

    }
    const handleFontSize = (value) => {
        const data = {
            font_size: value + 'px',
            line_height: value + 'px',
            id: currentItemProperty.property_id
        }
        dispatch(UpdateFontSize(data));

    }
    const handleLineHeight = (value) => {
        const data = {
            line_height: value + 'px',
            id: currentItemProperty.property_id
        }
        dispatch(UpdateLineHeight(data));

    }

    // const handleChangeFontSize = (event, newValue) => {
    //     const data = {
    //         font_size: newValue + 'px',
    //         id: currentItemProperty.property_id
    //     }
    //     dispatch(UpdateFontSize(data));
    // };

    const handleChangeColor = (color) => {
        const data = {
            color: color.hex,
            id: currentItemProperty.property_id
        }
        dispatch(UpdateFontColor(data));
    }
    
    const handleBackgroundColor = (color) => {
        const data = {
            background_color: color,
            id: currentItemProperty.property_id
        }
        dispatch(UpdateBackgroundColor(data));
    }
    const handleFontStroke = (value) => {
        let fontStroke = `${value.stroke}px ${value.stroke_color}`
        const data = {
            text_stroke: fontStroke,
            id: currentItemProperty.property_id
        }
         dispatch(UpdateTextStroke(data));
    }
    const handleBoxRotate = (value) => {
        let rotation = `${value}deg`
        const data = {
            rotate_box: rotation,
            id: currentItemProperty.property_id
        }
         dispatch(UpdateBoxRotation(data));
    }
    const handleRadioChange = (value) => {
        const data = {
            letter_spacing: value,
            id: currentItemProperty.property_id
        }

        dispatch(UpdateLetterSpacing(data));
    };
    const handleChangeAlignment = (value) => {
        const data = {
            text_alignment: value,
            id: currentItemProperty.property_id
        }
        dispatch(UpdateTextAlignment(data))
    }

    const handleStop = (event, dragElement) => {
        const data = {
            id: dragElement.node.id,
            position_x: dragElement.lastX,
            position_y: dragElement.lastY,
        }

        dispatch(UpdatePropertyTranslation(data));
    };



    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    const saveAll = () => {
        setLoading(true)
        var node = document.getElementById('created_image');
        domtoimage.toJpeg(node)
            .then(async function (dataUrl) {
                var img = new Image();
                img.src = dataUrl;
                var file = dataURLtoFile(dataUrl, 'my-invitation.jpg');
                var formData = new FormData();
                formData.append("image", JSON.stringify(createdImage));
                formData.append('image_property', JSON.stringify(imageProperties));
                formData.append('createPreview', file);

                let resp = await Images.saveImageWithProperties(formData);
                if (resp) {
                    if (resp.status) {
                        Alerts.alertMessage(resp.message, '', 'success', 'top-center')
                    } else {
                        Alerts.alertMessage(resp.message, '', 'danger')
                    }
                    setLoading(false)
                }
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    const addNewImage = (src) => {
        let maxZIndex = 30;
        const zIndexArr = [];
        const allImageProperties = imageProperties.filter(el => el.is_image === true);
        if (allImageProperties && allImageProperties.length !== 0) {
            allImageProperties.forEach(el => {
                zIndexArr.push(el.z_index)
            });
            maxZIndex = Math.max(...zIndexArr) + 1;
        }
        let newNote = {
            created_image_id: createdImage.id,
            property_id: uuidv4(),
            is_image: true,
            is_text: false,
            is_photo: false,
            text_label: null,
            font_size: null,
            width: '200px',
            height: 'auto',
            font_family: null,
            font_weight: null,
            letter_spacing: null,
            text_alignment: null,
            color: null,
            image_url: src,
            z_index: maxZIndex,
            translate_option: {
                position_x: 0,
                position_y: 0
            }
        };
        dispatch(AddImageProperty(newNote))

    }

    // const addImageFile = async (value) => {

    //     let formData = new FormData()
    //     formData.append("image_id", id);
    //     formData.append("property_id", uuidv4());
    //     formData.append("width", 200);
    //     formData.append("height", 'auto');
    //     formData.append("image", value);
    //     let resp = await Images.addImageProperyImage(formData);
    //     if (resp) {
    //         let pro = resp.created_property;
    //         let data = {
    //             created_image_id: id,
    //             property_id: pro.property_id,
    //             is_image: true,
    //             is_text: false,
    //             text_label: null,
    //             font_size: null,
    //             width: '200px',
    //             height: 'auto',
    //             font_family: null,
    //             font_weight: null,
    //             letter_spacing: null,
    //             text_alignment: null,
    //             color: null,
    //             image_url: pro.image_url,
    //             translate_option: {
    //                 position_x: 0,
    //                 position_y: 0
    //             }
    //         };
    //         dispatch(AddImageProperty(data))
    //     }
    // }
    const removeItem = async (id) => {
        var node = document.getElementById('created_image');
        dispatch(RemoveImageProperty(id));
        domtoimage.toJpeg(node)
            .then(async function (dataUrl) {
                var img = new Image();
                img.src = dataUrl;
                var file = dataURLtoFile(dataUrl, 'my-invitation.jpg');

                var formData = new FormData();
                formData.append('createPreview', file);
                formData.append('image_id', createdImage.id);
                formData.append('property_id', id);
                let resp = await Images.removeImageProperty(formData);
                if (resp) {
                    if (resp.status) {
                        //  imageProperties = imageProperties.filter(el=>el.property_id === id);
                        Alerts.alertMessage(resp.message, '', 'success', 'top-center')
                        //    window.location.reload();
                    } else {
                        Alerts.alertMessage(resp.message, '', 'danger')
                    }
                }


            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });






    }
    //ref
    const wrapperRef = useRef(null);
    const wrapperRef2 = useRef(null);
    useOutsideAlerter(wrapperRef, wrapperRef2, setEdit);


    const fSize = currentItemProperty !== null ? parseInt(currentItemProperty.font_size.slice(0, -2)) : 0;
    const lnHeight = currentItemProperty !== null ? parseInt(currentItemProperty.line_height.slice(0, -2)) : 0;
    const fFamily = currentItemProperty !== null ? currentItemProperty.font_family : '';
    const fColor = currentItemProperty !== null ? currentItemProperty.color : '';
    const fBackgroundColor = currentItemProperty !== null ? currentItemProperty.background_color : '';
    const fTextStroke = currentItemProperty !== null ? currentItemProperty.text_stroke : '';
    const fBoxRotate = currentItemProperty !== null ? currentItemProperty.rotate_box : '';


    return (
        <>
            <Breadcumb items={BreadcrumbData} />
            <div className="page-wrapper pd-0 mr-50">
                <Container className='pl'>
                    {
                        imageProperties &&
                        <>
                            <div className='image-top-tool' >
                                <div className='add-property'>
                                    <Button className='mr-10' variant="outlined" color="primary" onClick={addText}>
                                        <TextFieldsIcon fontSize="large" /> 
                                        {/* <AddIcon fontSize='small' /> */}
                                    </Button>

                                    <Button className='mr-10' variant="outlined" color="primary" onClick={openImageModal}>
                                        <InsertPhotoIcon fontSize="large" /> 
                                        {/* <AddIcon fontSize='small' /> */}
                                    </Button>
                                    <Button className='mr-10' variant="outlined" color="primary" onClick={openPhotoModal}>
                                        <PhotoCameraIcon fontSize="large" />
                                    </Button>

                                    {/* <Button variant="contained" color="primary" onClick={saveAll}>
                                        {isLoading ? 'Please wait..' : 'Save'}
                                    </Button> */}
                                </div>
                                <div className="image-tools" ref={wrapperRef2}>
                                    {
                                        isEdit ?

                                            <div className='inner-tool-wrapper'>
                                                <div className='font-family'>
                                                    <FontFamilyPicker fFamily={fFamily} handleFontFamily={handleChangeFontFamily} />
                                                </div>
                                                <div className='font-size'>
                                                    <ButtonGroup size="small" aria-label="small outlined button group">
                                                        {fSize > 0 && <Button onClick={() => handleFontSize(fSize - 1)}><RemoveIcon fontSize="small" /></Button>}
                                                        <input type="number" readOnly value={fSize} min="1" max="150" />
                                                        <Button onClick={() => handleFontSize(fSize + 1)}><AddIcon fontSize="small" /></Button>
                                                    </ButtonGroup>
                                                </div>
                                                <div className='lineHeight-picker'>
                                                    <LineHeightPicker lnHeight={lnHeight} handleLineHeight={handleLineHeight} />
                                                </div>
                                                <div className='lineHeight-picker'>
                                                    <StrokePicker fTextStroke={fTextStroke} handleFontStroke={handleFontStroke}/>
                                                </div>

                                                <div className='lineHeight-picker'>
                                                    <RotatePicker fBoxRotate={fBoxRotate} handleBoxRotate={handleBoxRotate} />
                                                </div>
                                                <div className='color-picker'>
                                                    <BackgroundColorPicker fBackgroundColor={fBackgroundColor} handleBackground={handleBackgroundColor}/>
                                                </div>

                                                <div className='color-picker'>
                                                    <ColorPicker fColor={fColor} handleColor={handleChangeColor} />
                                                </div>
                                                <div className='text-alignment'>
                                                    <AlignmentPicker align={currentItemProperty.text_alignment} handleChangeAlignment={handleChangeAlignment} />
                                                </div>
                                                <div className='letter-spacing'>
                                                    <LatterSpacingPicker letterSpacing={currentItemProperty.letter_spacing} handleRadioChange={handleRadioChange} />
                                                </div>
                                                <button className={'remove-btn-2'} onClick={() => removeItem(currentItemProperty.property_id)}>
                                                    <DeleteIcon />
                                                </button>
                                            </div>

                                            : null
                                    }
                                </div>
                                <div className='save-btn'>
                                    <Button variant="contained" color="primary" onClick={saveAll}>{isLoading ? 'Please wait..' : 'Save'}</Button>
                                </div>
                            </div>
                            <div className='empty-space'></div>
                            <div className="image-design">
                                <div id="created_image" className="create_image" >
                                    <div className='main_image'>
                                        <img src={createdImage?.image?.image} alt="main-img" />
                                    </div>
                                    <div className='drag-content'>
                                        {
                                            !showLoading && imageProperties && imageProperties.map((item, i) => {
                                                let styles = null;
                                                if (item.is_photo) {
                                                    styles = {
                                                        top: item.translate_option.position_y + 'px',
                                                        left: item.translate_option.position_x + 'px'
                                                    }
                                                }
                                               
                                               
                                                return (
                                                    <Draggable
                                                        key={item.property_id}
                                                        handle='.handle'
                                                        axis='both'
                                                        bounds='parent'
                                                        onStop={handleStop}
                                                        defaultPosition={{ x: item.translate_option.position_x, y: item.translate_option.position_y }}
                                                        style={styles}
                                                       >
                                                        <div className={`drag-item ${item.is_image || item.is_text ? `zid30` : ``} ${item.is_photo ? 'hasPhoto' : ''}`} id={`${item.property_id}`} ref={wrapperRef} style={styles}>
                                                            {item.is_image && <ImageCard item={item} updateImageSize={updateImageSize} removeItem={removeItem} />}
                                                            {item.is_text && <TextCard item={item} updateInputText={updateInputText} addFocus={addFocus} updateTextareaSize={updateTextareaSize} removeItem={removeItem} />}
                                                            {item.is_photo && <PhotoHolder item={item} updatePhoto={updatePhoto} updatePhotoHolderSize={updatePhotoHolderSize} removeItem={removeItem} />}
                                                        </div>
                                                    </Draggable>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>

                        </>
                    }
                </Container>

            </div>
            <AddPhotoModal isOpenPhotoModal={isOpenPhotoModal} closePhotoModal={closePhotoModal} addPhotoHolder={addPhotoHolder} />
            <AddImageModal addNewImage={addNewImage} isOpenImageModal={isOpenImageModal} openImageModal={openImageModal} closeImageModal={closeImageModal} />

        </>
    );
}

export default CreateImage;

